"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpVerb = exports.HTTP_HEADERS = void 0;
// HTTP Headers
// Note: Header names must be lowercase as they are stored that way in request.headers object
exports.HTTP_HEADERS = {
    AB_TEST_OVERRIDES: 'x-ab-test-overrides',
    HIL_MERCHANT_APPLICATION_RESUME_TOKEN: 'x-hil-merchant-application-resume-token',
};
var HttpVerb;
(function (HttpVerb) {
    HttpVerb["GET"] = "GET";
    HttpVerb["POST"] = "POST";
    HttpVerb["PUT"] = "PUT";
    HttpVerb["PATCH"] = "PATCH";
    HttpVerb["DELETE"] = "DELETE";
})(HttpVerb || (exports.HttpVerb = HttpVerb = {}));
